import React from 'react'
import styles from './BookInfluencer.module.css'; 
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck }
from "@fortawesome/free-solid-svg-icons";


const BookInfluencer = ({ clientdata, influencerdata,onClose}) => {
    const navigate = useNavigate();

    let data = {
      clientdata:clientdata,
      influencerdata:influencerdata
    }
const navigatetoAvailabilty = (recieved)=>{
    data ={
      ...data,
      type:recieved
    }
    navigate(`/checkavailability/${influencerdata._id}`,{ state: { data:data } });
  }
    return (
        <div className="container" style={{ maxWidth: '600px',overflowY: "auto",maxHeight: "80%" }}>
        <div className={`card ${styles.influencerCard}`}>
        <span className={`btn btn-outline-dark close-btn ${styles.closebutton}`} onClick={onClose}>&times;</span>
          <div className="card-body">
            {/* User Information */}

            {/* Influencer Information */}
            <div className="mt-4">             
              <p>
                <strong>Name:</strong> {influencerdata.firstName} {influencerdata.lastName}
              </p>
              
              <p>
                <strong>Category of Influence:</strong> {influencerdata.category}
              </p>
            </div>
    
            {/* About the Influencer */}
            <div className="mt-4">
              <h5>About the Influencer</h5>
              <p>{influencerdata.Intro}</p>
            </div>
    
            {/* Social Media Links */}
            <div className="mt-4">
              <h5>Social Media</h5>
              <div className="row">
                {influencerdata.Instagram && (
                  <div className="col-md-6 p-0">
                    <p>
                      <strong>Instagram:</strong> <br />
                       <a
            href={`https://www.instagram.com/${(influencerdata.Instagram).startsWith('@') ? (influencerdata.Instagram).slice(1) : influencerdata.Instagram}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.card_font}`}
            onClick={(e) => e.stopPropagation()} // Prevent card click
          >
            {(influencerdata.Instagram).startsWith('@') ? (influencerdata.Instagram).slice(1) : influencerdata.Instagram}
          </a>
                       {influencerdata.verifyInstagram &&(<span className={styles.verifiedTick}><FontAwesomeIcon
                        className=""
                        style={{marginRight:"-6px", marginLeft:"5px"}}
                        icon={faCircleCheck}
                      /></span>)}
                    </p>
                  </div>
                )}
                {influencerdata.Facebook && (
                  <div className="col-md-6 p-0">
                    <p>
                      <strong>Facebook:</strong> <br />
                      <a
            href={`https://www.facebook.com/${(influencerdata.Facebook).startsWith('@') ? (influencerdata.Facebook).slice(1) : influencerdata.Facebook}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.card_font}`}
            onClick={(e) => e.stopPropagation()} // Prevent card click
          >
            {(influencerdata.Facebook).startsWith('@') ? (influencerdata.Facebook).slice(1) : influencerdata.Facebook}
          </a>
                      {influencerdata.verifyFacebook&&(<span className={styles.verifiedTick}><FontAwesomeIcon
                        className=""
                        style={{marginRight:"-6px", marginLeft:"5px"}}
                                                icon={faCircleCheck}
                      /> </span>)}
                    </p>
                  </div>
                )}
                {influencerdata.Twitter && (
                  <div className="col-md-6 p-0">
                    <p>
                      <strong>X(Twitter):</strong> <br />
                       <a
            href={`https://x.com/${(influencerdata.Twitter).startsWith('@') ? (influencerdata.Twitter).slice(1) : influencerdata.Twitter}`}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.card_font}`}
            onClick={(e) => e.stopPropagation()} // Prevent card click
          >
            {(influencerdata.Twitter).startsWith('@') ? (influencerdata.Twitter).slice(1) : influencerdata.Twitter}
          </a>
                       {influencerdata.verifyTwitter &&(<span className={styles.verifiedTick}><FontAwesomeIcon
                        className=""
                        style={{marginRight:"-6px", marginLeft:"5px"}}
                                                icon={faCircleCheck}
                      /> </span>)}
                    </p>
                  </div>
                )}
                {influencerdata.Youtube && (
                  <div className="col-md-6 p-0">
                    <p>
                      <strong>LinkedIn:</strong> <br />
                       <a
                       href={`https://www.linkedin.com/in/${(influencerdata.Youtube).startsWith('@') ? (influencerdata.Youtube).slice(1) : influencerdata.Youtube}`}
                       target="_blank"
                       rel="noopener noreferrer"
                       className={`${styles.card_font}`}
                       onClick={(e) => e.stopPropagation()} // Prevent card click
                     >
                       {(influencerdata.Youtube).startsWith('@') ? (influencerdata.Youtube).slice(1) : influencerdata.Youtube}
                     </a>
                       {influencerdata.verifyYoutube &&(<span className={styles.verifiedTick}><FontAwesomeIcon
                        className=""
                        style={{marginRight:"-6px", marginLeft:"5px"}}
                                                icon={faCircleCheck}
                      /> </span>)}
                    </p>
                  </div>
                )}
              </div>
            </div>
    
            {/* Fee Information */}
            <div className="mt-4">
              <h5>Fee</h5>
              <p>
                <strong>Single Session (1:1) : </strong>
                {influencerdata.oldamount && 
                 influencerdata.oldamount > 0 && 
                 influencerdata.oldamount > influencerdata.amountforhalf ? (
                  <span className="discount-pricing">
                    <span className="old-price">
                      Rs {influencerdata.oldamount}
                    </span>
                    <span className="new-price">
                      Rs {influencerdata.amountforhalf}
                    </span>
                    <span className="discount-badge">
                      {Math.round(((influencerdata.oldamount - influencerdata.amountforhalf) / influencerdata.oldamount) * 100)}% OFF
                    </span>
                  </span>
                ) : (
                  <>Rs {influencerdata.amountforhalf}</>
                )}
              </p>
              <p>
                <strong>Group Session : </strong>
                {influencerdata.oldamount_full_group && 
                 influencerdata.oldamount_full_group > 0 && 
                 influencerdata.oldamount_full_group > influencerdata.amountforfull ? (
                  <span className="discount-pricing">
                    <span className="old-price">
                      Rs {influencerdata.oldamount_full_group}
                    </span>
                    <span className="new-price">
                      Rs {influencerdata.amountforfull}
                    </span>
                    <span className="discount-badge">
                      {Math.round(((influencerdata.oldamount_full_group - influencerdata.amountforfull) / influencerdata.oldamount_full_group) * 100)}% OFF
                    </span>
                  </span>
                ) : (
                  <>Rs {influencerdata.amountforfull}</>
                )}
              </p>
            </div>
    
            {/* Booking Buttons */}
            <div className="mt-4">
              <button className={`btn btn-primary inflanar-btn mr-2 ${styles.buttonsize}`} onClick={()=>navigatetoAvailabilty("Single")}>Book Session</button>
              {/* <button className={`btn btn-success ${styles.buttonsize}`} onClick={()=>navigatetoAvailabilty("Group")}>Attend Group Session</button>*/}
            </div>
          </div>
        </div>
        </div>
      );
    
}

export default BookInfluencer;